module.exports = __webpack_public_path__ + "img/store_vip_banner_wheat.8c7718ca.png";